// extracted by mini-css-extract-plugin
export default {"popup":"TradeInStatus_popup","shinyEffect":"TradeInStatus_shinyEffect","image":"TradeInStatus_image","error":"TradeInStatus_error","info":"TradeInStatus_info"};